import { safeSearchRegex } from '@adsk/alloy-react-helpers';

import {
  UseMentionSuggestionFilter,
  UseMentionSuggestionToMentionData,
  UseMentionSuggestionTypeToSize,
} from './types';
import {
  MentionType,
  MentionSupportedTypes,
  SLICE_START,
  MentionData,
} from '../../consts';

export const searchBySuggestionType = <T extends MentionSupportedTypes>(
  searchQuery: string,
  items: T[],
  mentionType: MentionType,
  filter: UseMentionSuggestionFilter,
  typeToSize: UseMentionSuggestionTypeToSize,
  toMentionData: UseMentionSuggestionToMentionData,
): MentionData[] => {
  const filteredItems = filter(items, mentionType);
  const lowerCasedSearchQuery = searchQuery.toLowerCase();
  const exactMatches = filteredItems.filter(
    ({ name }) => name.toLowerCase() === lowerCasedSearchQuery,
  );

  const withoutExactMatches = filteredItems.filter(
    ({ name }) => name.toLowerCase() !== lowerCasedSearchQuery,
  );

  // all matches without exact
  const moreMatches = withoutExactMatches.filter(({ name }) =>
    safeSearchRegex(searchQuery).test(name),
  );

  return toMentionData(
    [...exactMatches, ...moreMatches].slice(
      SLICE_START,
      typeToSize(mentionType),
    ),
    mentionType,
  );
};

export const getSuggestionsByType = <T extends MentionSupportedTypes>(
  items: T[],
  mentionType: MentionType,
  filter: UseMentionSuggestionFilter,
  typeToSize: UseMentionSuggestionTypeToSize,
  toMentionData: UseMentionSuggestionToMentionData,
): MentionData[] =>
  toMentionData(
    filter(items, mentionType).slice(SLICE_START, typeToSize(mentionType)),
    mentionType,
  );
